"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  badge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderStyle: 'solid',
    backgroundColor: theme.badge.backgroundColor,
    color: theme.badge.color,
    borderColor: theme.badge.borderColor,
    '&.hidden': {
      display: 'none'
    },
    '&.disabled': {
      opacity: theme.disabledOpacity
    }
  },
  small: {
    fontSize: 4,
    width: 6,
    minWidth: 6,
    height: 6,
    borderWidth: 1,
    borderRadius: 4
  },
  medium: {
    fontSize: 8,
    width: 10,
    minWidth: 10,
    height: 10,
    borderWidth: 2,
    borderRadius: 7
  },
  large: {
    fontSize: 10,
    width: 16,
    minWidth: 16,
    height: 16,
    borderWidth: 4,
    borderRadius: 12
  },
  xlarge: {
    fontSize: 12,
    width: 24,
    minWidth: 24,
    height: 24,
    borderWidth: 0,
    borderRadius: 12
  },
  xxlarge: {
    fontSize: 14,
    width: 32,
    minWidth: 32,
    height: 32,
    borderWidth: 0,
    borderRadius: 16
  }
});

exports.default = _default;